/**
 * Created by rickborst on 21/02/2017.
 */

class Session {

    /**
     * Constructs the model.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {
        this.token = options.token || '';
        this.refreshToken = options.refreshToken || '';
    }
}

export default Session;


// WEBPACK FOOTER //
// ./src/js/models/session.js